import { create } from 'zustand'

import {
    ERROR_CARD_UNSUPPORTED_FILE_CONTENT,
    ERROR_CARD_UNSUPPORTED_FILE_TITLE,
    HARMFUL_TOASTER_CARD_TITLE,
    HARMFUL_TOASTER__CARD_CONTENT,
    ERROR_FILE_SIZE_CARD_TITLE,
    ERROR_FILE_SIZE_CARD_CONTENT
} from 'constants/docUploadConstant'

const initialState = {
    title: '',
    content: '',
    show: false
}

export const useNotificationStore = create((set, get) => ({
    ...initialState,
    showNotification: (data) => set(data),
    resetNotificationStore: () => set(initialState),
    closeNotification: (event, reason) => {
        if (reason === 'clickaway') {
            return
        }
        get().showNotification({
            show: false
        })
    },
    showFileSizeNotification: () => {
        get().showNotification({
            title: ERROR_FILE_SIZE_CARD_TITLE,
            content: ERROR_FILE_SIZE_CARD_CONTENT,
            show: true
        })
    },
    showHarmfulNotification: () => {
        get().showNotification({
            title: HARMFUL_TOASTER_CARD_TITLE,
            content: HARMFUL_TOASTER__CARD_CONTENT,
            show: true
        })
    },
    showUnsupportedFileNotification: () => {
        get().showNotification({
            title: ERROR_CARD_UNSUPPORTED_FILE_TITLE,
            content: ERROR_CARD_UNSUPPORTED_FILE_CONTENT,
            show: true
        })
    }
}))
